/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba7ddcf4df74510631392f8b151e96e7>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/epic';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/epic/24';

/**
 * __24px `epic` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Epic24Icon = function Epic24Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  if (fg('icon-object-migration')) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: NewIcon,
      appearance: "purpleBold",
      size: "24",
      label: label,
      testId: testId,
      LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
        label: label,
        testId: testId
      })
    });
  } else {
    return /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    });
  }
};
Epic24Icon.displayName = 'Epic24Icon';
export default Epic24Icon;